/**
 * @file 编辑权限
 */
export default {
    canEditTopic(state, getters, rootState) {
        // 问答贴与文章：作者可编辑
        return rootState.header.isLogin
            && state.topicData.isAuthor;
    }
};
